import { fromPromise } from 'xstate'

import Api from '@/api/_legacy'

import { usersMachine } from '../../common/users.state'

const TENANT_ID = 'absa'

export const businessUnitUsersMachine = usersMachine.provide({
  actors: {
    fetchUsers: fromPromise(async ({ input: { context: ctx } }) => {
      const { businessUnitId } = ctx
      const response = await Api.tenant.usersDetail(businessUnitId, TENANT_ID)
      const { data } = response
      const { users } = data

      return users
    })
  }
})
